import $ from 'jquery';
import { Modal, Toast } from 'bootstrap';
import { library, dom } from '@fortawesome/fontawesome-svg-core';
import { faTriangleExclamation, faChevronLeft, faChevronDown, faWallet, faCheck } from '@fortawesome/free-solid-svg-icons';
import { createPopper } from '@popperjs/core';
library.add(faTriangleExclamation, faChevronLeft, faWallet, faCheck);

// Automatically replace <i> tags with SVG
dom.watch();

export const loadingOverlay = {
    Active: false,
    Show: (el) => {
        if(loadingOverlay.Active) return;
        const overlay = `<div class="loading-overlay">
            <div class="spinner-border text-light" role="status">
                <span class="visually-hidden">Loading...</span>
            </div>
        </div>`;
        $(el).append(overlay);
        loadingOverlay.Active = true;
    },
    Hide: (el) => {
        $(el).find('.loading-overlay').remove();
        loadingOverlay.Active = false;
    }
}

export const Toasts = {
    Success: {
        Show: (msg = "") => {
            let el = document.getElementById('toastSuccess');
            $(el).find('.toast-body').html(msg);
            let myToast = new Toast(el, {
                animation: true,
                autohide: true,
                delay: 5000
            });
            myToast.show();
        },
    },
    Error: {
        Show: (msg = "") => {
            let el = document.getElementById('toastError');
            $(el).find('.toast-body').html(msg);
            let myToast = new Toast(el, {
                animation: true,
                autohide: true,
                delay: 5000
            });
            myToast.show();
        },
    }
}

export const Modals = {
    PaymentSuccess: (signature = null) => {
        let el = $('#modalPayment');
        let content = $(el).find('.modal-body');
        let verifySignature = signature !== null ? `You can verify your payment via <a href="https://solscan.io/tx/${signature}" target="_blank">Solscan.io</a>.` : '';
        let html = `
            <div class="text-center">
                <i class="fa-solid fa-check fa-5x text-success"></i>
                <p class="fs-1 fw-light">Payment succeeded</p>
                <p>Your payment ID:</p>
                <p class="break-word">${signature}</p>
                <p>${verifySignature}</p>
                <button type="button" class="btn btn-primary my-3" data-bs-dismiss="modal">Ok</button>
            </div>
        `;
        content.html(html);
        let modal = new Modal($('#modalPayment'), {backdrop: 'static'});
        modal.show();
    },
    PaymentWarning: (message = null) => {
        let el = $('#modalPayment');
        let content = $(el).find('.modal-body');

        let html = `
            <div class="text-center">
                <i class="fa-solid fa-triangle-exclamation fa-5x text-warning"></i>
                <p class="fs-1 fw-light">Payment Warning</p>
                <p>Payment may not been executed</p>
                <p class="break-word">${message}</p>
                <button type="button" class="btn btn-primary my-3" data-bs-dismiss="modal">Ok</button>
            </div>
        `;
        content.html(html);
        let modal = new Modal($('#modalPayment'), {backdrop: 'static'});
        modal.show();
    },
    DefaultWarning: (title = "Warning", message = "") => {
        let el = $('#modalPayment');
        let content = $(el).find('.modal-body');

        let html = `
            <div class="text-center">
                <i class="fa-solid fa-triangle-exclamation fa-5x text-warning"></i>
                <p class="fs-1 fw-light">${title}</p>
                <p>${message}</p>
                <button type="button" class="btn btn-primary my-3" data-bs-dismiss="modal">Ok</button>
            </div>
        `;
        content.html(html);
        let modal = new Modal($('#modalPayment'), {backdrop: 'static'});
        modal.show();
    },
}


export const mobileCheck = function () {
    let check = false;
    (function (a) {
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4)))
            check = true;
    })(navigator.userAgent || navigator.vendor || window.opera);
    return check;
};